import {
  CourseMaterial,
  useCoursesLoaderData,
  useProgramDetails,
} from "./coursesLoader.ts";

export default function useProgramMetrics() {
  const { courses } = useCoursesLoaderData();
  const { scope, participating } = useProgramDetails();

  // Only calculate metrics for courses where the user is a learner
  const learnerMaterials = courses.reduce(
    (acc, { userRole, courseMaterials }) => {
      if (userRole === "learner" && courseMaterials) {
        acc.push(...courseMaterials);
      }
      return acc;
    },
    [] as CourseMaterial[]
  );

  const requiredIncluded = learnerMaterials.filter(
    (material) =>
      material.requiredCode === "required" &&
      (material.materialStatus === "opted_in" ||
        (scope === "ea_only" &&
          !participating &&
          material.materialStatus === "opted_out"))
  );

  const optableItems = courses
    .map((course) =>
      (course.courseMaterials ?? []).filter(
        (material) =>
          (material.materialStatus === "opted_in" ||
            material.materialStatus === "opted_out") &&
          material.requiredCode === "required"
      )
    )
    .flat();

  const totalOptableItems = optableItems.length;

  const optedOutItems = optableItems.filter(
    (material) => material.materialStatus === "opted_out"
  );

  const programCost = requiredIncluded.reduce<number>((acc, cur) => {
    const price = Number(cur.studentPrice);
    if (isNaN(price)) {
      return acc;
    }
    return (acc += price);
  }, 0);

  return {
    numCourses: courses.length,
    requiredIncludedCount: requiredIncluded.length,
    programCost,
    hasOptableItems: totalOptableItems > 0,
    totalOptedOutItems: optedOutItems.length,
    totalOptableItems,
  };
}
